<app-dialog-container></app-dialog-container>
<div class="app-container">
  <app-loading *ngIf="!isLoaded"></app-loading>
  <router-outlet *ngIf="isLoaded"></router-outlet>
</div>
